// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__H7I2L","panel":"Robot_panel__D-Z2S","wrapper":"Robot_wrapper__KRjW+","info":"Robot_info__CVXIN","unit":"Robot_unit__K5xA7"};